import { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Field } from "../components/bits";

const Frame = ({ title, children, testId }) => (
  <div className="landing" data-testid={testId}><section className="landing-right" style={{ margin: "0 auto" }}>
    <div style={{ width: "100%", maxWidth: 420 }}><Link to="/" className="brand" style={{ padding: 0, marginBottom: 28, textDecoration: "none", color: "var(--ink)", display: "inline-flex" }}><b>ExperTraQ</b></Link>
      <h2 style={{ marginBottom: 14 }}>{title}</h2>{children}</div></section></div>
);

export function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  const { refreshUser } = useAuth();
  useEffect(() => {
    const t = params.get("token");
    if (!t) return setState("missing");
    api.get("/auth/verify-email", { params: { token: t } }).then(() => { setState("ok"); refreshUser(); }).catch(() => setState("bad"));
  }, [params, refreshUser]);
  return (
    <Frame title="Email confirmation" testId="verify-email-page">
      {state === "working" && <p>Confirming…</p>}
      {state === "ok" && <div className="note" data-testid="verify-ok"><b>Your email is confirmed.</b> Every feature is now unlocked. <Link to="/today">Go to Today →</Link></div>}
      {(state === "bad" || state === "missing") && <div className="note bad" data-testid="verify-bad">This link is invalid or has expired. Sign in and use "Resend verification email".</div>}
    </Frame>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => { e.preventDefault(); try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (ex) { toast.error(errText(ex)); } };
  return (
    <Frame title="Reset your password" testId="forgot-page">
      {sent ? <div className="note" data-testid="forgot-sent">If an account exists for that email, a reset link has been sent. It works once and expires in 1 hour.</div> : (
        <form onSubmit={submit} data-testid="forgot-form">
          <Field label="Email"><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" /></Field>
          <button className="btn w-full justify-center" data-testid="forgot-submit-btn">Send reset link</button>
        </form>)}
      <p className="sub mt-4"><Link to="/login">Back to sign in</Link></p>
    </Frame>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refreshUser } = useAuth();
  const [f, setF] = useState({ p: "", c: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.p !== f.c) return toast.error("Passwords do not match");
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", new_password: f.p }); await refreshUser(); toast.success("Password reset. You are signed in."); nav("/today"); } catch (ex) { toast.error(errText(ex)); }
  };
  return (
    <Frame title="Choose a new password" testId="reset-page">
      <form onSubmit={submit} data-testid="reset-form">
        <Field label="New password (12+ chars, letter + number)"><input type="password" value={f.p} onChange={(e) => setF({ ...f, p: e.target.value })} required minLength={12} data-testid="reset-password-input" /></Field>
        <Field label="Confirm"><input type="password" value={f.c} onChange={(e) => setF({ ...f, c: e.target.value })} required minLength={12} data-testid="reset-confirm-input" /></Field>
        <button className="btn w-full justify-center" data-testid="reset-submit-btn">Set new password</button>
      </form>
    </Frame>
  );
}

export const VerifyBanner = () => {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified !== false) return null;
  const resend = async () => { try { await api.post("/auth/resend-verification"); setSent(true); toast.success("Verification email sent"); } catch (ex) { toast.error(errText(ex)); } };
  return (
    <div className="preview-banner" data-testid="verify-banner">
      <span><b>Verify your email to unlock all features.</b> Public profile, client portal, referral rewards and paid plans stay locked until you confirm <b>{user.email}</b>.</span>
      <button className="btn sm" onClick={resend} disabled={sent} data-testid="resend-verification-btn">{sent ? "Sent" : "Resend verification email"}</button>
    </div>
  );
};
